import { Component, OnInit, ViewChild } from '@angular/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AddItemsModelComponent } from '../add-items-model/add-items-model.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';

export interface PeriodicElement {
  sNo: number;
  ptbGrades: string;
  pmiGrades: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { sNo: 1, ptbGrades: 'BM', pmiGrades: "X3F" },
  { sNo: 2, ptbGrades: 'BR', pmiGrades: "X4F" },
  { sNo: 3, ptbGrades: 'BL', pmiGrades: "X3L" },
  { sNo: 4, ptbGrades: 'MMC', pmiGrades: "C3F" },
  { sNo: 5, ptbGrades: 'HG', pmiGrades: "X3D" },
  { sNo: 6, ptbGrades: 'MLC', pmiGrades: "C3L" },
  { sNo: 7, ptbGrades: 'BD', pmiGrades: "B3F" },
  { sNo: 8, ptbGrades: 'MMB', pmiGrades: "C4L" },
  { sNo: 9, ptbGrades: 'BM', pmiGrades: "X3F" },
  { sNo: 10, ptbGrades: 'BM', pmiGrades: "M3F" },
  { sNo: 11, ptbGrades: 'BM', pmiGrades: "D6F" },
  { sNo: 12, ptbGrades: 'BM', pmiGrades: "Z2P" },

];

export interface PeriodicElementType{
  sNo: number;
  tobaccoType: string;
}

const ELEMENT_DATA_TYPE: PeriodicElementType[] = [
  { sNo: 1, tobaccoType: 'Cigars' },
  { sNo: 2, tobaccoType: 'Cigarettes' },
  { sNo: 3, tobaccoType: 'Smokeless Tobacco' },
  { sNo: 4, tobaccoType: 'Hookah' },
  { sNo: 5, tobaccoType: 'Chewing Tobacco' },
  { sNo: 6, tobaccoType: 'Burley' },
  { sNo: 7, tobaccoType: 'Low-Yield Cigarettes' },
  { sNo: 8, tobaccoType: 'Snuff' },
  { sNo: 9, tobaccoType: 'Snus' },
  { sNo: 10, tobaccoType: 'Electronic Cigarettes' },
  { sNo: 11, tobaccoType: 'Latakia' },
  { sNo: 12, tobaccoType: 'Criollo' }

];

/**
 * @title Basic use of `<table mat-table>`
 */

@Component({
  selector: 'app-admin-portal',
  templateUrl: './admin-portal.component.html',
  styleUrls: ['./admin-portal.component.scss']
})
export class AdminPortalComponent implements OnInit {

  selectedFile: File | undefined;
  matfocused = false;
  

  displayedColumns: string[] = ['sNo', 'ptbGrades', 'pmiGrades', 'action'];
  dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);

  displayedColumns2: string[] = ['sNo', 'tobaccoType','action'];
  dataSource2 = new MatTableDataSource<PeriodicElementType>(ELEMENT_DATA_TYPE);

  constructor(public dialog: MatDialog, private _liveAnnouncer: LiveAnnouncer, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
  }

  onFileSelected(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      this.selectedFile = inputElement.files[0];
      this._snackBar.open('File Uploaded', 'Splash', {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        duration: 3000
      });
    } else {
      this.selectedFile = undefined;
    }
  }

  
  openSuccessDialog() {
    const dialogConfig = new MatDialogConfig();
    // Set the custom height and width here (in pixels)
    dialogConfig.minHeight = '234px';
    dialogConfig.minWidth = '343px';

    // You can also set other properties of the dialog
    dialogConfig.disableClose = true; // Prevent closing the dialog by clicking outside
    dialogConfig.autoFocus = true;    // Set focus to the first focusable element inside the dialog

    this.dialog.open(SuccessPopupComponent, dialogConfig);
  }


  addItemDialog() {
    const dialogConfig = new MatDialogConfig();
    // Set the custom height and width here (in pixels)
    dialogConfig.minHeight = '234px';
    dialogConfig.minWidth = '343px';
    
    // You can also set other properties of the dialog
    dialogConfig.disableClose = true; // Prevent closing the dialog by clicking outside
    dialogConfig.autoFocus = true;    // Set focus to the first focusable element inside the dialog

    this.dialog.open(AddItemsModelComponent, dialogConfig);
  }


  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


}
